import React, { useState, useEffect, ChangeEvent, useRef } from 'react';
import { Box, Button, Grid, IconButton, TextField, Typography, Menu, MenuItem, useTheme, FormControlLabel, Checkbox, } from '@mui/material';
import BasicTable, { Column } from '../../components/table';
import axios from 'axios';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Link, Navigate } from 'react-router-dom';
import { useNavigate, useLocation } from "react-router-dom";
import Select from '@mui/material/Select';
import { toast } from 'react-toastify';
import { ThemeProvider } from '@mui/material/styles';
import getTheme from '../../theme/theme';
import { SelectChangeEvent } from '@mui/material/Select';
import { BASEURL, ARROW, SIGN_FONT, IMAGEURL, FONT_SIZE, AUTOFILL_STYLES, ConfirmationDialog } from "../../constants/Common";
import { todolist } from './Todolists';
import { Backdrop, CircularProgress, } from "@mui/material";
import FloatingButton from '../../pages/usersupport/helpdesk/FloatingButton';

interface ProgressUpdate {
  id: number;
  createddate: string;
  createdby: string;
  remarks: string;
  trackingid: number;
  attachments: string | null;
  attachments2: string | null;
  attachments3: string | null;
  attachments4: string | null;
  attachments5: string | null;
  attachments6: string | null;
  signature: string;
  initials: string;

}

interface ProjectNames {
  id: number;
  project_name: string;
  project_status: string;
}
interface User {
  id: number;
  username: string;
}

const TodolistEdit = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const [editeddata, setEditeddata] = useState<todolist | null>(null);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [progressUpdates, setProgressUpdates] = useState<ProgressUpdate[]>([]);
  const location = useLocation();
  const [assignedUsers, setAssignedUsers] = useState<string[]>([]); // Users assigned to the selected project
  const orgid = localStorage.getItem('orgid');
  const userid = localStorage.getItem('userid');
  const mergedListRef = useRef(0);
  const [projectNamesData, setProjectNamesData] = useState<ProjectNames[]>([]);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [checkedItems, setCheckedItems] = useState<boolean[]>([]);
  const [isSaving, setIsSaving] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    const argtodolistData = location?.state;
    const todolistDetails = argtodolistData?.todolistDetails;

    if (todolistDetails && !editeddata) {
      setEditeddata(todolistDetails as todolist);

    }

    const l_projectNamesData = argtodolistData?.projectNamesData;
    if (l_projectNamesData) {
      setProjectNamesData(l_projectNamesData);
    }

    const l_progressUpdates = argtodolistData?.progressUpdates;
    if (l_progressUpdates) {
      setProgressUpdates(l_progressUpdates);
    }
    if (editeddata?.project_id && mergedListRef.current === 0) {
      fetchAssignedUsers(editeddata.project_id);
      mergedListRef.current = 1;
    }
  }, [location, editeddata]);


  const fetchAssignedUsers = async (projectId: any) => {
    try {
      const response = await axios.get(`${BASEURL}/api/assignedusers/${projectId}/?orgid=${orgid}&userid=${userid}`,
        {
          headers: { 'Content-Type': 'multipart/form-data', },
        }
      );
      if (response.status === 200) {
        const assignedUsersList = response.data.users;
        setAssignedUsers(assignedUsersList.map((user: any) => user.username));
      }
    } catch (error) {
      console.error('Error fetching assigned users:', error);
    }
  };



  const columns: Column[] = [
    { id: 'date', label: 'Date', align: 'left' },
    { id: 'entryby', label: 'Entry By', align: 'left' },
    { id: 'remarks', label: 'Remarks', align: 'left' },
    { id: 'attachments', label: 'Attachments', align: 'left' },
    { id: 'signature', label: 'Signature', align: 'left' },

  ];


  const renderAttachment = (progress: any) => {
    let att1 = getAttachmentsUrl(progress?.attachments)
    let att2 = getAttachmentsUrl(progress?.attachments2)
    let att3 = getAttachmentsUrl(progress?.attachments3)
    let att4 = getAttachmentsUrl(progress?.attachments4)
    let att5 = getAttachmentsUrl(progress?.attachments5)
    let att6 = getAttachmentsUrl(progress?.attachments6)
    return (
      <>
        {att1} {att2 && <br />}
        {att2} {att3 && <br />}
        {att3} {att4 && <br />}
        {att4} {att5 && <br />}
        {att5} {att6 && <br />}
        {att6}
      </>
    );
  }


  const downloadImage = async (imageUrl : string) => {
    const imageUrlPath = BASEURL + '/download_image' ;

    if (imageUrl) {
      try {
        // Fetch the image blob using the imageUrl from the metadata
   //     const response = await axios.get(imageUrlPath, {
        const response = await axios.get(`${imageUrlPath}?image_name=${encodeURIComponent(imageUrl)}`, {
            responseType: 'blob',
        });

        // Create a URL for the blob object
        const blob = new Blob([response.data], { type: 'image/jpeg' });
        const downloadUrl = window.URL.createObjectURL(blob);

        const fileName = imageUrl.substring(imageUrl.lastIndexOf('/') + 1);

        // Create an anchor element and trigger a download
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', fileName); // You can also dynamically set the filename here
        document.body.appendChild(link);
        link.click();
        link.remove();  // Clean up by removing the link
      } catch (error) {
        console.error('Failed to download the image:', error);
      }
    }
  };




  const getAttachmentsUrl = (attachmentUrl: string | null) => {
    return attachmentUrl ? (
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault(); // Prevent default link behavior
          downloadImage(attachmentUrl); // Call the downloadImage function
        }}
      >
        {attachmentUrl.split('/').pop()} {/* Display file name */}
      </a>
    ) : '';
  };

  const rows = progressUpdates
    .filter(progress => progress.trackingid === editeddata?.id)
    .map(progress => ({
      date: progress.createddate,
      entryby: progress.createdby,
      remarks: progress.remarks,
      attachments: renderAttachment(progress),
      // signature: progress.initials,
      signature: (
        <span style={{ fontSize: FONT_SIZE }}>
          {progress.initials}
        </span>
      ),

    }));

  rows.reverse();

  function getTodayDate() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    return `${year}-${month}-${date}`;
  }


  const handleCancelClick = () => {
    setEditeddata((prevState) => ({
      ...prevState!,
      remarks: '',
      attachments: null, attachments2: null, attachments3: null,
      attachments4: null, attachments5: null, attachments6: null,
      signature: '',
      initials: '',
    }));
    navigate('/todolist-details', { state: { todolistDetails: editeddata, projectNamesData: projectNamesData } });
  };

  const validateInput = () => {
    if (editeddata?.projectname.length === 0) {
      toast.error("Please select projectname.")
      return false;
    }
    if (editeddata?.status.length === 0) {
      toast.error("Please select To-do list status.")
      return false;
    }
    if (editeddata?.title.length === 0) {
      toast.error("Please enter To-do list title.")
      return false;
    }
    if (editeddata?.priority.length === 0) {
      toast.error("Please select priority.")
      return false;
    }
    if (editeddata?.createdby.length === 0) {
      toast.error("Please enter createdby.")
      return false;
    }
    if (editeddata?.createddate.length == 0) {
      toast.error("Please enter created date.")
      return false;
    }
    if (editeddata?.assignedto.length == 0) {
      toast.error("Please enter assigned to details.")
      return false;
    }
    if (editeddata?.assignedto.length == 0) {
      toast.error("Please enter checklist details.")
      return false;
    }
    if (editeddata?.remarks === undefined || editeddata?.remarks === "") {
      toast.error("Please enter Remarks.")
      return false;
    }
    if (editeddata?.initials === undefined || editeddata?.initials === "") {
      toast.error("Signature is required.")
      return false;
    }
    return true
  }

  const handleSaveClick = async () => {
    if (!editeddata) {
      console.error('No To-do list selected');
      setIsSaving(false);
      return;
    }
    let ret = validateInput();
    if (!ret) {
      setIsSaving(false);
      return;
    }
    setIsLoading(true);
    setIsSaving(true);

    try {
      const editedtodolistData = {
        createddate: editeddata.createddate,
        title: editeddata.title,
        status: editeddata.status,
        projectname: editeddata.projectname,
        project_id: editeddata.project_id,
        createdby: editeddata.createdby,
        priority: editeddata.priority,
        assignedto: editeddata.assignedto,
        description: editeddata.description,
        checklist: JSON.stringify(
          JSON.parse(editeddata.checklist).map((item: { text: string; checked: boolean }, index: number) => ({
            ...item,
            checked: checkedItems[index] ?? item.checked,
          }))
        ),
        remarks: editeddata.remarks,
        initials: editeddata.initials,
      };

      const response = await axios.put(
        BASEURL + `/todolists/${editeddata.id}/`,
        editedtodolistData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.status === 200) {
        const hasRemarks = editeddata.remarks !== undefined && editeddata.remarks !== "";
        const hasAttachments = selectedFiles.some(file => file !== undefined);

        if (hasRemarks || hasAttachments) {
          const progressUpdateData = {
            createddate: getTodayDate(),
            createdby: editeddata.createdby,
            remarks: editeddata.remarks,
            attachments: selectedFiles[0] || null,
            attachments2: selectedFiles[1] || null,
            attachments3: selectedFiles[2] || null,
            attachments4: selectedFiles[3] || null,
            attachments5: selectedFiles[4] || null,
            attachments6: selectedFiles[5] || null,
            initials: editeddata.initials,
            trackingid: editeddata.id,
          };

          const progressUpdateResponse = await axios.post(
            BASEURL + `/todolists/${editeddata.id}/progressupdate/create/`,
            progressUpdateData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          );

          toast.success("To-do list details are updated.");

          setProgressUpdates(prevProgressUpdates => [...prevProgressUpdates, progressUpdateResponse.data]);
          setSelectedFiles([]);
          editeddata.remarks = '';
          editeddata.initials = '';

        } else {
          toast.success("To-do list details are updated.")
        }
        navigate('/todolist-details', { state: { todolistDetails: editeddata, projectNamesData: projectNamesData } });

      }
    } catch (error) {
      toast.error('Error saving To-do list');
      setIsSaving(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDialogOpen = () => {
    setAnchorEl(null);
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleDeleteClick = async () => {
    setOpenDialog(false);
    try {
      const url_delete = BASEURL + `/todolists/${editeddata?.id}/`
      await axios.delete(url_delete);
      toast.success('To-do list deleted successfully');
      navigate('/todolists')
    } catch (error) {
      toast.error('Error deleting To-do list');
      console.log(error)
    }
  };

  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    let newAttachments: File | null = null;

    if (name === 'attachments' && event.target instanceof HTMLInputElement) {
      const files = event.target.files;
      if (files && files.length > 0) {
        newAttachments = files[0];
      }
    }

    setEditeddata((prevState) => ({
      ...prevState!,
      [name]: name === 'attachments' ? newAttachments : value,
    }));
  };

  const handleProjectNameChange = (event: SelectChangeEvent<string>) => {
    const valueProjectID = parseInt(event.target.value);
    const selProjectNameArray = projectNamesData.find(project => project.id === valueProjectID);

    if (selProjectNameArray) {
      const selProjectName = selProjectNameArray.project_name;

      setEditeddata((prevState) => ({
        ...prevState!,
        projectname: selProjectName,
        project_id: event.target.value
      }));

      // Fetch assigned users for the selected project
      fetchAssignedUsers(valueProjectID);
    }
  };

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    const { name, value } = event.target;
    setEditeddata((prevState) => ({
      ...prevState!,
      [name]: value,
    }));
  };


  const handleFilesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = Array.from(event.target.files!) as File[];

    const uniqueFilesToAdd = newFiles.filter((file) => !selectedFiles.some((selectedFile) => selectedFile.name === file.name));

    if ((uniqueFilesToAdd.length + selectedFiles.length) > 6) {
      toast.error('You can only upload up to 6 files.');
      return;
    }

    setSelectedFiles((prevFiles) => [...prevFiles, ...uniqueFilesToAdd]);

  };



  const handleButtonClick = (evt: any) => {
    evt.preventDefault();
    if (selectedFiles.length > 5)
      toast.error("You can upload maximum of 6 files.")
    else {
      let obj = document.getElementById('fileInput');
      if (obj != null)
        obj.click();
    }
  };


  const handleRemoveFile = (fileName: string) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
  };

  const statusOptions = ['Pending', 'In progress', 'Completed'];

  const renderStatusOptions = () => {
    return statusOptions.map((option) => (
      <MenuItem key={option} value={option}>
        {option}
      </MenuItem>
    ));
  };

  const priorityOptions = ['Low', 'Normal', 'High'];
  const renderpriorityOptions = () => {
    return priorityOptions.map((option) => (
      <MenuItem key={option} value={option}>
        {option}
      </MenuItem>
    ));
  };

  const handleCheckboxChange = (index: number) => (event: ChangeEvent<HTMLInputElement>) => {
    const updatedCheckedItems = [...checkedItems];
    updatedCheckedItems[index] = event.target.checked;
    setCheckedItems(updatedCheckedItems);
    setEditeddata((prevState) => {
      if (prevState) {
        const updatedChecklist = JSON.parse(prevState.checklist).map((item: any, i: number) =>
          i === index ? { ...item, checked: event.target.checked } : item
        );
        return {
          ...prevState,
          checklist: JSON.stringify(updatedChecklist),
        };
      }
      return prevState;
    });
  };

  const renderChecklistItems = () => {
    if (editeddata && editeddata.checklist) {
      const checklistArray = JSON.parse(editeddata.checklist) as { text: string; checked: boolean }[];

      return checklistArray.map((item, index) => (
        <FormControlLabel
          key={index}
          control={
            <Checkbox
              checked={item.checked}
              onChange={handleCheckboxChange(index)}
              sx={{
                '& .MuiSvgIcon-root': { fontSize: 25 },
                '&.Mui-checked': {
                  color: 'black',
                },
              }}
            />
          }
          label={item.text}
          sx={{
            mb: 0.5,
            '& .MuiFormControlLabel-label': { fontSize: '16px' },
            display: 'flex',
            alignItems: 'center',
          }}
        />
      ));
    }
    return null;
  };


  return (
    <ThemeProvider theme={getTheme()}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color='inherit' />
      </Backdrop>

      <Box sx={{ position: 'relative', top: 0, right: 0, mt: '-70px' }}>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant='h6' component='div'>
            <Link to={'/todolists'} >To-do lists</Link> {ARROW}Edit
          </Typography>
          <Box sx={{ marginLeft: 'auto' }}>
            <IconButton
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={(event) => setAnchorEl(event.currentTarget)}
              sx={{ marginRight: '30px' }}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
            >
              <MenuItem onClick={handleDialogOpen}>Delete</MenuItem>
            </Menu>
          </Box>
          <ConfirmationDialog
            open={openDialog}
            handleClose={handleDialogClose}
            handleConfirm={handleDeleteClick}
            message="Are you sure you wanted to delete this item? This action is irreversible."
            title="Confirm Deletion"
          />
        </Box>

      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '10px',
        }}
      >

      </Box>
      {editeddata ? (
        <Box sx={{ mt: '-30px' }}>

          <Grid container spacing={2} sx={{ mt: '30px' }}>
            <Grid item xs={12}>
              <Box>
                <Grid container spacing={2}>

                  <Grid item xs={12} sm={6} md={3}>
                    <p><strong>Title</strong></p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      variant='outlined'
                      name='title'
                      value={editeddata?.title || ''}
                      onChange={handleChange}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <p><strong>Project Name</strong></p>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>


                    <div>
                      <div>
                        <Box sx={{ mt: "0px", border: '1px solid #000000' }}>
                          <Select
                            value={editeddata.project_id}
                            onChange={handleProjectNameChange}
                            fullWidth
                            variant="outlined"
                            name="projectname"
                            sx={{ textAlign: "left", textJustify: "center", }}
                          >
                            {projectNamesData.filter(project => project.project_status !== 'Completed').map((project, index) => (
                              <MenuItem key={index} value={project.id}
                                sx={{
                                  color: '#000000',
                                  fontSize: '18px',
                                }}>
                                {project.project_name}
                              </MenuItem>
                            ))}
                          </Select>
                        </Box>
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <p><strong>Status</strong></p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>

                    <Box sx={{ border: '1px solid #000000' }}>
                      <Select
                        value={editeddata?.status || ''}
                        onChange={handleSelectChange}
                        name='status'
                        variant='outlined'
                        fullWidth
                        sx={{
                          ...AUTOFILL_STYLES(theme),
                        }}
                      >
                        {statusOptions.map((option) => (
                          <MenuItem key={option}
                            value={option}
                            selected={option === editeddata?.status}
                            sx={{
                              color: '#000000',
                              fontSize: '18px',
                            }}> {/* Set value to the option */}
                            {option}
                          </MenuItem>))}
                      </Select>
                    </Box>

                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <p><strong>Created By</strong></p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    {editeddata?.createdby}
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <p><strong>Assigned To</strong></p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>

                    <div>
                      <div>
                        <Box sx={{ mt: "0px", border: '1px solid #000000' }}>
                          <Select
                            value={editeddata.assignedto}
                            onChange={handleSelectChange}
                            fullWidth
                            variant="outlined"
                            name="assignedto"
                            sx={{ textAlign: "left", textJustify: "center", }}
                          >
                            {assignedUsers.map((type: string) => (
                              <MenuItem key={type} value={type}
                                sx={{
                                  color: '#000000',
                                  fontSize: '18px',
                                }}>
                                {type}
                              </MenuItem>
                            ))}
                          </Select>
                        </Box>
                      </div>
                    </div>
                  </Grid>


                  <Grid item xs={12} sm={6} md={3}>
                    <strong>Created Date </strong>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    {editeddata?.createddate}
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <p><strong>Description</strong> (optional)</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>

                    <TextField
                      variant='outlined'
                      name='description'
                      value={editeddata?.description || ''}
                      onChange={handleChange}
                      multiline
                      rows={5}
                      sx={{}}
                      fullWidth
                    />

                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <p><strong>Priority</strong></p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>

                    <Box sx={{ border: '1px solid #000000' }}>
                      <Select
                        value={editeddata?.priority || ''}
                        onChange={handleSelectChange}
                        name='priority'
                        variant='outlined'
                        fullWidth
                        sx={{
                          ...AUTOFILL_STYLES(theme),
                        }}
                      >
                        {priorityOptions.map((option) => (
                          <MenuItem key={option}
                            value={option}
                            selected={option === editeddata?.priority}
                            sx={{
                              color: '#000000',
                              fontSize: '18px',
                            }}> {/* Set value to the option */}
                            {option}
                          </MenuItem>))}
                      </Select>
                    </Box>

                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <p><strong>Checklist</strong></p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>

                    {renderChecklistItems()}
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <p><strong>Remarks</strong></p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>

                    <TextField
                      variant='outlined'
                      name='remarks' multiline rows={5}
                      onChange={handleChange}
                      sx={{
                        ...AUTOFILL_STYLES(theme),
                      }}
                      fullWidth
                    />

                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <p><strong>Attachments</strong> (optional)</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>

                    <div>
                      <input id="fileInput"
                        type="file"
                        name="file"
                        onChange={handleFilesChange}
                        accept=".jpg, .jpeg, .png"
                        multiple
                        style={{ display: 'none' }}
                      />
                      <Button variant='contained' color='primary' onClick={handleButtonClick}>Browse</Button>
                    </div>

                    {(
                      selectedFiles.map((file: any) => (
                        <div key={file.name}>
                          <Grid mt={1} container spacing={0} sx={{ mt: 1 }}>
                            <Grid item md={6} xs={12} sx={{ wordWrap: 'break-word' }} >
                              <span style={{ display: 'block', overflowWrap: 'break-word' }}>{file.name}</span>
                            </Grid>
                            <Grid item md={3} xs={12} style={{ marginLeft: '0px' }}>
                              <Button color='error'
                                 variant='text' onClick={() => handleRemoveFile(file.name)}
                                 sx={{ mt: { xs: 1, md: 0 } }}>Remove</Button>
                            </Grid>
                          </Grid>
                        </div>
                      ))
                    )}

                  </Grid>
                  <>
                    <Grid item xs={12} sm={6} md={3}>
                      <p><strong>Signature</strong></p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      {(
                        <div style={{
                          display: 'flex', flexDirection: 'column', border: '1px solid #ccc',
                          paddingLeft: 5, paddingRight: 5, paddingBottom: 5, paddingTop: 0,
                        }}> {/* Wrap Sign in flex container with column layout and border */}
                          <TextField
                            name={'initials'} type={'text'} value={editeddata ? editeddata['initials'] : ''}
                            onChange={handleChange}
                            fullWidth margin='dense' variant='outlined'
                            sx={{
                              ...AUTOFILL_STYLES(theme),
                            }}
                          />

                          <span style={{
                            fontFamily: SIGN_FONT, minHeight: '50px', maxWidth: '100#', whiteSpace: 'pre-wrap',
                            fontSize: FONT_SIZE, border: '2px solid #ccc', padding: 5
                          }}>
                            {editeddata ? editeddata['initials'] : ''}
                          </span>
                        </div>
                      )}
                    </Grid>
                  </>

                </Grid>
              </Box>
            </Grid>
          </Grid>

          <Box sx={{ mt: '50px', display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant='contained' onClick={handleSaveClick} sx={{ marginRight: '20px', width: '75px', '&:disabled': { bgcolor: 'grey.400', color: 'grey.700' } }} disabled={isSaving}>
              Save
            </Button>
            <Button
              variant='contained'
              onClick={handleCancelClick}
              sx={{ marginRight: '10px', width: '75px' }}
            >
              Cancel
            </Button>

          </Box>

          {/*  -----------------code for progress table starts here--------------------*/}

          <h3 style={{ marginTop: '60px' }}>Progress Update</h3>
          <Box sx={{ marginTop: '30px', ml: '-35px', mr: '-40px' }}>
            <BasicTable columns={columns} rows={rows} />
          </Box>

        </Box>
      ) : (
        <p>No To-do list selected</p>
      )}
      <FloatingButton />
    </ThemeProvider>
  );
};

export default TodolistEdit;